export default __webpack_public_path__ + "static/media/CAN.a8d60863.svg";